const SCROLL_EDGE_TOLERANCE = 2;

const updateAlphabetEdges = (alphabet) => {
  const maxScrollLeft = Math.max(0, alphabet.scrollWidth - alphabet.clientWidth);
  alphabet.classList.toggle('is-scroll-start', alphabet.scrollLeft <= SCROLL_EDGE_TOLERANCE);
  alphabet.classList.toggle('is-scroll-end', alphabet.scrollLeft >= maxScrollLeft - SCROLL_EDGE_TOLERANCE);
};

const enhanceAlphabet = (alphabet) => {
  if (alphabet.dataset.roasterAlphabetReady === 'true') return;

  alphabet.dataset.roasterAlphabetReady = 'true';
  const update = () => updateAlphabetEdges(alphabet);
  alphabet.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(alphabet);
  update();
};

document.querySelectorAll('[data-roaster-alphabet]').forEach(enhanceAlphabet);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-roaster-alphabet]').forEach(enhanceAlphabet);
});

// Keep the decorative pending-launch loop asleep outside the viewport.
const comingSoonObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        target.toggleAttribute('data-coming-soon-visible', isIntersecting);
      });
    })
  : null;
const observeComingSoonChips = (root) => {
  root.querySelectorAll('.roaster-card__new-chip.roaster-coming-soon-chip').forEach((chip) => {
    comingSoonObserver?.observe(chip);
  });
};
observeComingSoonChips(document);
document.addEventListener('shopify:section:load', (event) => observeComingSoonChips(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.roaster-coming-soon-chip').forEach((chip) => comingSoonObserver?.unobserve(chip));
});
